import React, { useEffect } from "react";
import { Footer } from "../components/Relaunch";
import { Navigation } from "../components/navigation";

const AppTerms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navigation /><main id="main">
      
      <div id="terms-of-use" className="text-left">
        <div className="container">
          <div className="terms-header">
            <h1>Termos de Uso do CoffeeIn Club</h1>
            <p className="last-updated">Última atualização: 23 de outubro de 2025</p>
          </div>

          <div className="terms-content">
            <section>
              <h2>1. Aceitação dos Termos</h2>
              <p>
                Bem-vindo ao CoffeeIn Club. Estes Termos de Uso ("Termos") regulam o uso do aplicativo 
                móvel CoffeeIn Club e de todos os serviços relacionados oferecidos por nós ("Serviço", 
                "Aplicativo" ou "CoffeeIn Club").
              </p>
              <p>
                Ao acessar ou usar o CoffeeIn Club, você concorda em ficar vinculado a estes Termos. 
                Se você não concordar com qualquer parte destes Termos, não deve usar nosso Serviço.
              </p>
              <p>
                Estes Termos constituem um acordo legalmente vinculativo entre você e o CoffeeIn Club. 
                Ao criar uma conta, assinar um plano ou usar qualquer funcionalidade do aplicativo, você 
                confirma que leu, compreendeu e concorda com todos os termos e condições aqui descritos.
              </p>
            </section>

            <section>
              <h2>2. Definições</h2>
              <ul>
                <li><strong>"Nós", "Nosso", "CoffeeIn Club":</strong> Refere-se à empresa operadora do 
                aplicativo e serviços relacionados.</li>
                <li><strong>"Você", "Usuário", "Cliente":</strong> Refere-se à pessoa física ou jurídica 
                que acessa ou utiliza o aplicativo.</li>
                <li><strong>"Cafeteria", "Estabelecimento Parceiro":</strong> Refere-se às cafeterias 
                que participam do programa CoffeeIn Club e oferecem cupons através do aplicativo.</li>
                <li><strong>"Serviço":</strong> Refere-se ao aplicativo móvel, plataforma, website e 
                todos os serviços relacionados oferecidos pelo CoffeeIn Club.</li>
                <li><strong>"Conta":</strong> Refere-se à conta de usuário criada no aplicativo.</li>
                <li><strong>"Cupom":</strong> Refere-se aos cupons de desconto criados e gerenciados 
                pelas cafeterias parceiras, disponíveis para resgate através do aplicativo.</li>
                <li><strong>"Assinatura":</strong> Refere-se ao plano de assinatura mensal oferecido 
                pelo CoffeeIn Club que concede acesso aos benefícios e cupons disponíveis.</li>
                <li><strong>"Sistema de Indicação":</strong> Refere-se ao programa de indicação de 
                amigos onde usuários podem receber benefícios por cada indicação bem-sucedida.</li>
              </ul>
            </section>

            <section>
              <h2>3. Elegibilidade e Cadastro</h2>
              
              <h3>3.1 Requisitos de Idade</h3>
              <p>
                Você deve ter pelo menos 18 anos de idade para usar o CoffeeIn Club. Ao criar uma conta, 
                você declara e garante que tem pelo menos 18 anos e tem capacidade legal para celebrar 
                este acordo.
              </p>
              <p>
                Se você tem entre 13 e 17 anos, pode usar o aplicativo apenas com a supervisão e 
                consentimento de um pai ou responsável legal que aceita estes Termos em seu nome.
              </p>

              <h3>3.2 Criação de Conta</h3>
              <p>
                Para usar certas funcionalidades do aplicativo, você precisará criar uma conta fornecendo 
                informações precisas, completas e atualizadas, incluindo:
              </p>
              <ul>
                <li>Nome completo</li>
                <li>Endereço de e-mail válido</li>
              </ul>
              <p>
                Você é responsável por todas as atividades que ocorrem sob sua conta.
              </p>

              <h3>3.3 Verificação de Conta</h3>
              <p>
                Podemos exigir que você verifique sua identidade ou outras informações fornecidas. 
                Reservamo-nos o direito de suspender ou encerrar contas que forneçam informações 
                falsas, incompletas ou enganosas.
              </p>
            </section>

            <section>
              <h2>4. Uso do Aplicativo</h2>
              
              <h3>4.1 Licença de Uso</h3>
              <p>
                Concedemos a você uma licença limitada, não exclusiva, não transferível e revogável 
                para usar o aplicativo CoffeeIn Club para fins pessoais e não comerciais, de acordo 
                com estes Termos.
              </p>

              <h3>4.2 Restrições de Uso</h3>
              <p>Você concorda em NÃO:</p>
              <ul>
                <li>Usar o aplicativo para qualquer finalidade ilegal ou não autorizada</li>
                <li>Violar qualquer lei local, estadual, nacional ou internacional</li>
                <li>Interferir ou interromper o funcionamento do aplicativo ou servidores</li>
                <li>Tentar obter acesso não autorizado a qualquer parte do aplicativo</li>
                <li>Usar bots, scripts ou outros métodos automatizados para acessar o aplicativo</li>
                <li>Copiar, modificar, distribuir, vender ou alugar qualquer parte do aplicativo</li>
                <li>Fazer engenharia reversa, descompilar ou desmontar o aplicativo</li>
                <li>Usar o aplicativo de forma que possa danificar, desabilitar, sobrecarregar ou 
                comprometer nossos sistemas</li>
                <li>Criar contas falsas ou múltiplas contas para fraudar o sistema</li>
                <li>Usar o aplicativo para transmitir vírus, malware ou código malicioso</li>
                <li>Colher informações de outros usuários sem autorização</li>
                <li>Usar o aplicativo de forma que viole os direitos de propriedade intelectual de 
                terceiros</li>
              </ul>

              <h3>4.3 Modificações do Serviço</h3>
              <p>
                Reservamo-nos o direito de modificar, suspender ou descontinuar qualquer aspecto do 
                aplicativo a qualquer momento, com ou sem aviso prévio. Não seremos responsáveis por 
                qualquer modificação, suspensão ou descontinuação do serviço.
              </p>
            </section>

            <section>
              <h2>5. Cupons e Descontos</h2>
              
              <h3>5.1 Sistema de Cupons</h3>
              <p>
                O CoffeeIn Club oferece uma plataforma onde cafeterias parceiras criam e gerenciam 
                seus próprios cupons de desconto. Os cupons são disponibilizados para resgate através 
                do aplicativo por usuários que possuem uma assinatura ativa.
              </p>
              <p>
                As cafeterias parceiras são totalmente responsáveis por criar, gerenciar, aplicar e 
                remover cupons. O CoffeeIn Club atua apenas como intermediário, fornecendo a plataforma 
                para disponibilização desses cupons.
              </p>

              <h3>5.2 Gerenciamento de Cupons</h3>
              <p>
                As cafeterias parceiras podem criar, modificar, suspender ou remover cupons a qualquer 
                momento, sem aviso prévio. O CoffeeIn Club não se responsabiliza pela disponibilidade, 
                validade ou remoção de cupons criados pelas cafeterias parceiras.
              </p>
              <p>
                Você reconhece que os cupons podem ser removidos ou alterados sem notificação prévia 
                e que o CoffeeIn Club não tem controle sobre a disponibilidade ou condições dos cupons 
                oferecidos pelas cafeterias parceiras.
              </p>

              <h3>5.3 Uso de Cupons</h3>
              <p>
                Os cupons são válidos apenas nas condições especificadas pela cafeteria parceira e 
                podem ter restrições, prazos de validade e limitações de uso. Você não pode transferir, 
                vender ou negociar cupons. Cupons fraudados ou obtidos ilegalmente serão invalidados.
              </p>
              <p>
                O resgate e aplicação dos descontos são de responsabilidade da cafeteria parceira. 
                Qualquer disputa relacionada a cupons ou descontos deve ser resolvida diretamente com 
                a cafeteria parceira.
              </p>
            </section>

            <section>
              <h2>6. Assinatura</h2>
              
              <h3>6.1 Plano de Assinatura</h3>
              <p>
                O CoffeeIn Club oferece planos de assinatura mensal que concedem acesso aos cupons 
                e benefícios disponíveis no aplicativo. Ao assinar um plano, você concorda em pagar 
                a taxa de assinatura recorrente conforme o plano selecionado.
              </p>
              <p>
                Os valores das assinaturas, benefícios incluídos e condições podem ser alterados a 
                qualquer momento, com notificação prévia aos assinantes.
              </p>

              <h3>6.2 Renovação Automática</h3>
              <p>
                As assinaturas são renovadas automaticamente no final de cada período de cobrança (mensal), 
                a menos que você cancele antes da data de renovação. Ao renovar, você autoriza o 
                processamento do pagamento pelo valor da assinatura.
              </p>

              <h3>6.3 Cancelamento de Assinatura</h3>
              <p>
                Você pode cancelar sua assinatura a qualquer momento através das configurações do 
                aplicativo ou entrando em contato com nosso suporte. O cancelamento será efetivado 
                ao final do período de validade do plano atual.
              </p>
              <p>
                Ao cancelar, você manterá acesso aos benefícios e cupons até o final do período de 
                validade do plano que já foi pago. Após o término do período, você perderá o acesso 
                aos benefícios e cupons disponíveis apenas para assinantes.
              </p>

              <h3>6.4 Direito de Arrependimento e Reembolso</h3>
              <p>
                Em conformidade com o Código de Defesa do Consumidor (CDC), você tem o direito de 
                cancelar sua assinatura e solicitar reembolso integral se o cancelamento ocorrer 
                dentro de 7 (sete) dias corridos a partir da data da assinatura inicial.
              </p>
              <p>
                Após o período de 7 dias, não haverá reembolso proporcional ou integral. O cancelamento 
                será efetivado ao final do período de validade do plano já pago, conforme descrito na 
                seção 6.3.
              </p>
              <p>
                Para solicitar reembolso dentro do prazo legal, entre em contato com nosso suporte 
                através do e-mail suporte@coffeein.club. O reembolso será processado em até 10 dias 
                úteis, utilizando o mesmo método de pagamento utilizado na assinatura.
              </p>

              <h3>6.5 Pagamentos</h3>
              <p>
                Os pagamentos das assinaturas são processados através de provedores de pagamento seguros 
                de terceiros. Você concorda em fornecer informações de pagamento precisas e atualizadas. 
                Ao assinar um plano, você autoriza o processamento recorrente do pagamento.
              </p>
              <p>
                Se o pagamento falhar, sua assinatura pode ser suspensa até que o pagamento seja 
                processado com sucesso. Reservamo-nos o direito de encerrar assinaturas com pagamentos 
                recorrentes falhados.
              </p>
            </section>

            <section>
              <h2>7. Sistema de Indicação</h2>
              
              <h3>7.1 Programa de Indicação</h3>
              <p>
                O CoffeeIn Club oferece um sistema de indicação onde usuários podem indicar amigos 
                para usar o aplicativo. Ao indicar um amigo que se cadastra e assina um plano, ambos 
                podem receber benefícios.
              </p>

              <h3>7.2 Benefícios da Indicação</h3>
              <p>
                Para cada amigo indicado que:
              </p>
              <ul>
                <li>Se cadastra no aplicativo através do seu link de indicação</li>
                <li>Assina um plano de assinatura</li>
                <li>Permanecer com a assinatura ativa por pelo menos 7 (sete) dias consecutivos</li>
              </ul>
              <p>
                Você receberá 30 (trinta) dias gratuitos de assinatura adicionados à sua conta.
              </p>

              <h3>7.3 Regras do Sistema de Indicação</h3>
              <ul>
                <li>As indicações são válidas apenas para novos usuários que ainda não possuem conta 
                no CoffeeIn Club</li>
                <li>O amigo indicado deve usar o link de indicação fornecido por você</li>
                <li>O período de 7 dias consecutivos de assinatura ativa do indicado é verificado 
                automaticamente pelo sistema</li>
                <li>Os 30 dias gratuitos serão creditados automaticamente após a confirmação de que o 
                indicado completou 7 dias de assinatura ativa</li>
                <li>Os dias gratuitos são adicionados ao final do período atual de sua assinatura</li>
                <li>Não há limite para o número de indicações que você pode fazer</li>
              </ul>

              <h3>7.4 Fraude e Abuso</h3>
              <p>
                Qualquer tentativa de fraude ou abuso do sistema de indicação, incluindo criação de 
                contas falsas, uso de múltiplas contas para auto-indicação, ou qualquer método fraudulento, 
                resultará na suspensão ou encerramento da conta e perda de todos os benefícios obtidos 
                de forma fraudulenta.
              </p>
              <p>
                Reservamo-nos o direito de investigar e tomar ações apropriadas contra qualquer uso 
                fraudulento do sistema de indicação.
              </p>
            </section>

            <section>
              <h2>8. Conteúdo do Usuário</h2>
              
              <h3>8.1 Responsabilidade pelo Conteúdo</h3>
              <p>
                Você é responsável por todo o conteúdo que você envia, publica ou transmite através 
                do aplicativo, incluindo comentários, avaliações, fotos e mensagens ("Conteúdo do 
                Usuário").
              </p>

              <h3>8.2 Licença de Conteúdo</h3>
              <p>
                Ao enviar Conteúdo do Usuário, você concede ao CoffeeIn Club uma licença mundial, 
                não exclusiva, livre de royalties, perpétua e transferível para usar, reproduzir, 
                modificar, adaptar, publicar, traduzir e distribuir esse conteúdo em qualquer meio.
              </p>

              <h3>8.3 Conteúdo Proibido</h3>
              <p>Você não pode postar Conteúdo do Usuário que:</p>
              <ul>
                <li>Seja ilegal, difamatório, calunioso, obsceno ou ofensivo</li>
                <li>Contenha conteúdo adulto, pornográfico ou sexualmente explícito</li>
                <li>Promova, glorifique ou faça referência a drogas ilícitas ou uso de substâncias controladas</li>
                <li>Viole direitos de propriedade intelectual de terceiros</li>
                <li>Contenha vírus, malware ou código malicioso</li>
                <li>Seja spam, publicidade não autorizada ou conteúdo promocional</li>
                <li>Viole a privacidade de terceiros</li>
                <li>Seja falso, enganoso ou fraudulento</li>
                <li>Incite violência, discriminação ou ódio</li>
              </ul>

              <h3>8.4 Remoção de Conteúdo</h3>
              <p>
                Reservamo-nos o direito de remover, editar ou recusar qualquer Conteúdo do Usuário 
                que viole estes Termos ou que consideremos inapropriado, sem aviso prévio.
              </p>
            </section>

            <section>
              <h2>9. Propriedade Intelectual</h2>
              <p>
                O aplicativo CoffeeIn Club, incluindo seu design, logotipos, textos, gráficos, 
                imagens, código-fonte e software, é propriedade do CoffeeIn Club ou de seus 
                licenciadores e está protegido por leis de direitos autorais, marcas registradas 
                e outras leis de propriedade intelectual.
              </p>
              <p>
                Você não pode usar, copiar, reproduzir, modificar, distribuir ou criar obras derivadas 
                de qualquer parte do aplicativo sem nossa autorização prévia por escrito.
              </p>
              <p>
                O nome "CoffeeIn Club" e os logotipos relacionados são marcas registradas do CoffeeIn 
                Club. Você não pode usar essas marcas sem nossa autorização prévia por escrito.
              </p>
            </section>

            <section>
              <h2>10. Limitação de Responsabilidade</h2>
              
              <h3>10.1 Isenção de Garantias</h3>
              <p>
                O aplicativo é fornecido "como está" e "conforme disponível", sem garantias de qualquer 
                tipo, expressas ou implícitas. Não garantimos que o aplicativo será ininterrupto, 
                livre de erros, vírus ou outros componentes prejudiciais.
              </p>

              <h3>10.2 Limitação de Responsabilidade</h3>
              <p>
                Na medida máxima permitida por lei, o CoffeeIn Club não será responsável por quaisquer 
                danos diretos, indiretos, incidentais, especiais, consequenciais ou punitivos decorrentes 
                do uso ou incapacidade de usar o aplicativo, incluindo, mas não limitado a:
              </p>
              <ul>
                <li>Perda de dados ou informações</li>
                <li>Perda de receita ou lucros</li>
                <li>Interrupção de negócios</li>
                <li>Danos resultantes de produtos ou serviços de cafeterias parceiras</li>
                <li>Problemas relacionados a pagamentos</li>
                <li>Problemas técnicos ou falhas do sistema</li>
              </ul>

              <h3>10.3 Responsabilidade das Cafeterias Parceiras</h3>
              <p>
                O CoffeeIn Club atua como intermediário entre você e as cafeterias parceiras. Não somos 
                responsáveis pela qualidade, segurança, adequação ou legalidade dos produtos ou serviços 
                oferecidos pelas cafeterias parceiras, nem pela criação, gerenciamento, disponibilidade ou 
                remoção de cupons. Qualquer disputa relacionada a cupons, produtos ou serviços deve ser 
                resolvida diretamente com a cafeteria parceira.
              </p>
            </section>

            <section>
              <h2>11. Indenização</h2>
              <p>
                Você concorda em indenizar, defender e isentar o CoffeeIn Club, seus diretores, 
                funcionários, agentes e licenciadores de e contra quaisquer reivindicações, danos, 
                obrigações, perdas, responsabilidades, custos ou despesas (incluindo honorários 
                advocatícios) decorrentes de:
              </p>
              <ul>
                <li>Seu uso do aplicativo</li>
                <li>Violação destes Termos</li>
                <li>Violação de qualquer direito de terceiros</li>
                <li>Conteúdo do Usuário que você posta ou transmite</li>
                <li>Qualquer atividade relacionada à sua conta</li>
              </ul>
            </section>

            <section>
              <h2>12. Privacidade</h2>
              <p>
                Sua privacidade é importante para nós. Nossa coleta e uso de suas informações pessoais 
                é regida pela nossa Política de Privacidade, que faz parte destes Termos por referência. 
                Ao usar o aplicativo, você concorda com a coleta e uso de informações conforme descrito 
                na Política de Privacidade.
              </p>
              <p>
                Para mais informações, consulte nossa Política de Privacidade disponível em: 
                <a href="/app-privacy" style={{ color: '#5d4037', textDecoration: 'underline' }}>
                  coffeein.club/app-privacy
                </a>
              </p>
            </section>

            <section>
              <h2>13. Encerramento de Conta</h2>
              
              <h3>13.1 Encerramento por Você</h3>
              <p>
                Você pode encerrar sua conta a qualquer momento através das configurações do aplicativo 
                ou entrando em contato com nosso suporte.
              </p>

              <h3>13.2 Encerramento por Nós</h3>
              <p>
                Reservamo-nos o direito de suspender ou encerrar sua conta imediatamente, sem aviso 
                prévio, se você:
              </p>
              <ul>
                <li>Violar estes Termos</li>
                <li>Usar o aplicativo de forma fraudulenta ou ilegal</li>
                <li>Fornecer informações falsas ou enganosas</li>
                <li>Abusar do serviço ou de outros usuários</li>
                <li>Não pagar taxas ou encargos devidos</li>
                <li>Por qualquer outro motivo a nosso critério</li>
              </ul>

              <h3>13.3 Efeitos do Encerramento</h3>
              <p>
                Após o encerramento, você não terá mais acesso à sua conta ou aos dados associados. 
                Poderemos reter certas informações conforme necessário para cumprir obrigações legais 
                ou resolver disputas.
              </p>
            </section>

            <section>
              <h2>14. Disputas e Resolução</h2>
              
              <h3>14.1 Lei Aplicável</h3>
              <p>
                Estes Termos são regidos pelas leis do Brasil, sem considerar conflitos de princípios 
                legais.
              </p>

              <h3>14.2 Resolução de Disputas</h3>
              <p>
                Em caso de disputa, você concorda em primeiro tentar resolver a questão entrando em 
                contato com nosso suporte. Se não conseguirmos resolver a disputa amigavelmente dentro 
                de 60 dias, você concorda em submeter a disputa à mediação antes de buscar ação judicial.
              </p>

              <h3>14.3 Foro e Jurisdição</h3>
              <p>
                Fica eleito o foro da Comarca de Curitiba, Estado do Paraná, para dirimir quaisquer 
                controvérsias oriundas destes Termos, renunciando as partes a qualquer outro, por mais 
                privilegiado que seja.
              </p>
              <p>
                Qualquer ação legal relacionada a estes Termos será submetida à jurisdição exclusiva 
                dos tribunais competentes da Comarca de Curitiba, Estado do Paraná.
              </p>
            </section>

            <section>
              <h2>15. Alterações nos Termos</h2>
              <p>
                Reservamo-nos o direito de modificar estes Termos a qualquer momento. Notificaremos 
                você sobre alterações significativas através do aplicativo ou por e-mail. A data da 
                "Última atualização" no topo desta página indica quando os Termos foram revisados pela 
                última vez.
              </p>
              <p>
                Seu uso continuado do aplicativo após tais modificações constitui sua aceitação dos 
                Termos revisados. Se você não concordar com as alterações, deve parar de usar o 
                aplicativo e encerrar sua conta.
              </p>
              <p>
                Recomendamos que você revise estes Termos periodicamente para se manter informado sobre 
                suas responsabilidades e direitos.
              </p>
            </section>

            <section>
              <h2>16. Disposições Gerais</h2>
              
              <h3>16.1 Integridade do Contrato</h3>
              <p>
                Estes Termos, juntamente com a Política de Privacidade, constituem o acordo completo 
                entre você e o CoffeeIn Club em relação ao uso do aplicativo e substituem todos os 
                acordos anteriores.
              </p>

              <h3>16.2 Renúncia</h3>
              <p>
                Nossa falha em exercer ou fazer valer qualquer direito ou disposição destes Termos não 
                constituirá uma renúncia a tal direito ou disposição.
              </p>

              <h3>16.3 Divisibilidade</h3>
              <p>
                Se qualquer disposição destes Termos for considerada inválida ou inexequível, as 
                disposições restantes permanecerão em pleno vigor e efeito.
              </p>

              <h3>16.4 Transferência</h3>
              <p>
                Você não pode transferir ou ceder seus direitos ou obrigações sob estes Termos sem 
                nossa autorização prévia por escrito. Podemos transferir nossos direitos e obrigações 
                sob estes Termos sem restrição.
              </p>

              <h3>16.5 Notificações</h3>
              <p>
                Podemos enviar notificações a você através do aplicativo, por e-mail ou por outros 
                meios razoáveis. Você é responsável por manter suas informações de contato atualizadas.
              </p>
            </section>

            <section>
              <h2>17. Contato</h2>
              <p>
                Se você tiver dúvidas, preocupações ou solicitações relacionadas a estes Termos de Uso, 
                entre em contato conosco:
              </p>
              <div className="contact-info">
                <p><strong>E-mail de Suporte:</strong> suporte@coffeein.club</p>
                <p><strong>E-mail Jurídico:</strong> legal@coffeein.club</p>
                <p><strong>E-mail Geral:</strong> contato@coffeein.club</p>
              </div>
              <p>
                Responderemos às suas solicitações dentro de um prazo razoável.
              </p>
            </section>

            <section>
              <h2>18. Consentimento</h2>
              <p>
                Ao utilizar o CoffeeIn Club, você reconhece que leu, compreendeu e concorda em ficar 
                vinculado a estes Termos de Uso e à nossa Política de Privacidade.
              </p>
              <p>
                Se você não concordar com qualquer parte destes Termos, não deve usar o aplicativo 
                CoffeeIn Club.
              </p>
            </section>
          </div>
        </div>
      </div>

      </main><Footer />
    </div>
  );
};

export default AppTerms;


